module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/customer-card-list/customer-card-list.component.scss
// module id = ./src/app/modules/backstage-module/components/customer-card-list/customer-card-list.component.scss
// module chunks = 9